import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/app/(auth)/forgot-password/forgot-password-form.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/public/images/auth-decoration.png");
;
import(/* webpackMode: "eager" */ "/home/node/app/public/images/auth-image.jpg");
